module.exports = "bootstrap-datepicker";